/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsRepeatH: {
  name: 'arrows-repeat-h';
  data: string;
} = {
  name: 'arrows-repeat-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.354 1.354a.5.5 0 1 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 1 0 .708-.708L2.207 3.5H14a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 1 0V4A1.5 1.5 0 0 0 14 2.5H2.207l1.147-1.146Zm12 12a.5.5 0 0 0 0-.708l-2-2a.5.5 0 0 0-.708.708l1.147 1.146H2a.5.5 0 0 1-.5-.5V9a.5.5 0 0 0-1 0v3A1.5 1.5 0 0 0 2 13.5h11.793l-1.147 1.146a.5.5 0 0 0 .708.708l2-2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
